import React, { useState, useEffect } from 'react';
import '../../../App.css';
import {Link} from "react-router-dom";
import '../../../App.css';
import './LandingPageNavbar.css'
import './Navbar.css';
import {useTranslation} from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

function Navbar() {
    const { t } = useTranslation();
    const [click, setClick] = useState(false);
    const [servicesDropdown, setServicesDropdown] = useState(false);

    const handleServicesMouseEnter = () => {
        setServicesDropdown(true);
    };

    const handleServicesMouseLeave = () => {
        setServicesDropdown(false);
    };


    return (
        <>
            <nav className="landing-page-navbar">
                <div className="navbar-container">
                    <ul className={click ? 'landing-page-nav-menu active' : 'landing-page-nav-menu'}>
                        <li className="nav-item">
                            <Link to="/home" className="nav-links">
                                Home
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to='/projects' className="nav-links">
                                {t("Projects")}
                            </Link>
                        </li>
                        <li
                            className="nav-item"
                            onMouseEnter={handleServicesMouseEnter}
                            onMouseLeave={handleServicesMouseLeave}
                        >
                            <Link to="/services" className="nav-links">
                                {t("Services")}
                            </Link>
                            {servicesDropdown && (
                                <ul className="landing-page-dropdown-menu">
                                    <li className="dropdown-item">
                                        <Link to="/services/olikes-anakainiseis"
                                              className="dropdown-link">{t("Complete Renovations")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/special-constructions"
                                              className="dropdown-link">{t("Special Constructions")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/bedrooms"
                                              className="dropdown-link">{t("Bedrooms")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/floor" className="dropdown-link">{t("Flooring")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/bathrooms" className="dropdown-link">{t("Bathrooms")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/kitchens" className="dropdown-link">{t("Kitchens")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/living-rooms"
                                              className="dropdown-link">{t("Living Rooms")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/lighting" className="dropdown-link">{t("Lighting")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/aluminum-frames"
                                              className="dropdown-link">{t("Aluminum Frames")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/smart-home"
                                              className="dropdown-link" >{t("Smart Home")}</Link>
                                    </li>
                                    <li className="dropdown-item">
                                        <Link to="/services/exterior-spaces"
                                              className="dropdown-link">{t("Exterior Spaces")}</Link>
                                    </li>
                                </ul>
                            )}
                        </li>
                        <li className="nav-item">
                            <Link to="/company" className="nav-links">
                                {t("Company")}
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/contact" className="nav-links">
                                {t("Contact")}
                            </Link>
                        </li>
                        <li className="language-selector">
                            <LanguageSwitcher/>
                        </li>
                    </ul>
                </div>
            </nav>
        </>

    )
}

export default Navbar
